import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

const state = () => ({ titleDetailsViewedCount: 0 });

export type AdState = ReturnType<typeof state>;

const getters: GetterTree<AdState, any> = {
	titleDetailsViewedCount(state): number {
		return state.titleDetailsViewedCount;
	},
};

const actions: ActionTree<AdState, any> = {
	setTitleDetailsViewCount({ commit }, count) {
		commit('SET_TITLE_DETAILS_VIEWED_COUNT', count);
	},
};

const mutations: MutationTree<AdState> = {
	SET_TITLE_DETAILS_VIEWED_COUNT(state, viewedCount) {
		state.titleDetailsViewedCount = viewedCount;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
} as Module<AdState, any>;
